import { ref, computed } from "vue";
import { useDistributionStore } from "./store/useDistributionStore";
import { useDistributionNavigationStore } from "./store/useDistributionNavigationStore";
import { getShortDateString } from "@/services/utils";
import UpdateDistributionModal from "./modals/UpdateDistributionModal.vue";
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';
import ExportJson from "@/services/ExportJsonService";
import Loader from "@/components/Loader.vue";
import LlTooltip from "@/components/LlTooltip.vue";
export default {
  name: "DistributionDetail",
  props: {
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    modalService: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader,
    LlTooltip,
    UpdateDistributionModal,
    LlCheckbox,
    LlSecondaryButton,
    LlSelect
  },
  setup(props) {
    const loading = ref(true);
    const me = ref({});
    const showOrigination = ref(false);
    const accounting = ref(false);
    const distributionDetail = ref({});
    const selectedDistributions = ref([]);
    const distributionStore = useDistributionStore();
    const distributionNavigationStore = useDistributionNavigationStore();
    const showDialog = ref(false);
    const newDistribution = ref({
      share: true,
      origination: true,
      responsible: true,
      referral: true,
      expenses: true
    });
    const saveForFutureInfo = computed(() => {
      const {
        share,
        origination,
        responsible,
        expenses,
        referral
      } = newDistribution.value;
      const details = [];
      if (!share) details.push("Share");
      if (!origination) details.push("Origination");
      if (!responsible) details.push("Responsible");
      if (!referral) details.push("Referral");
      if (!expenses) details.push("Expenses");
      return details.length ? details.join(", ") : "";
    });
    const getDistributionDetail = async () => {
      loading.value = true;
      await distributionStore.listDistributionDetail({
        distributionId: distributionNavigationStore.section.distributionId
      });

      // set up distribution detail
      distributionDetail.value = distributionStore.distributionDetail;
      selectedDistributions.value = distributionStore.distributionsList.distributions.find(distribution => {
        return distribution.id === distributionNavigationStore.section.distributionId;
      });
      const status = await props.accountingService.verify(false);
      me.value = await props.userService.getMe();
      accounting.value = status.connected;
      const settings = me.value.company.settings.report || {};
      showOrigination.value = accounting.value && (!isNaN(settings.originatingContribution) || !isNaN(settings.originatingContributionFirm) || me.value.features.referral);
      loading.value = false;
    };
    function distributionChange(distributionId) {
      newDistribution.value.newDistribution = distributionId;
    }
    function sectionToggle(value) {
      distributionNavigationStore.section.selectedSectionToggle = value;
    }
    function print() {
      window.print();
    }
    function exportCSV() {
      const items = distributionDetail.value.users.reduce((accum, user) => {
        const lead = me.value.terms?.Lead;
        accum.push({
          [lead]: user.user.name,
          Share: user.data.origination.share,
          Origination: user.data.origination.originatorDebit,
          Responsible: user.data.origination.responsibleDebit,
          Expenses: user.data.collected.expensesUsers
        });
        return accum;
      }, []);
      const exportJson = new ExportJson();
      exportJson.downloadCsv(items, "Distribution Review");
    }
    function sendToQuickBooks() {
      distributionStore.processDistribution({
        param: distributionNavigationStore.section.distributionId,
        distributionId: newDistribution.value
      });
    }
    function changeStatus() {
      const {
        status
      } = selectedDistributions.value;
      selectedDistributions.value.status = status === 'Distributed' ? "Draft" : "Distributed";
      distributionStore.updateDistirbutionStatus(selectedDistributions.value);
    }
    function cancelDistributionSettings() {
      showDialog.value = false;
      newDistribution.value = {
        share: true,
        origination: true,
        responsible: true,
        referral: true,
        expenses: true
      };
    }
    function applyDistributionSettings() {
      showDialog.value = false;
      if (!newDistribution.value.share) {
        distributionDetail.value.users.map(user => user.data.collected.distributionSummaryTotal -= user.data.origination.share);
        distributionDetail.value.users.map(user => distributionDetail.value.data.collected.distributionSummaryTotal -= user.data.origination.share);
        distributionDetail.value.data.origination.share = 0;
        distributionDetail.value.users.map(user => user.data.origination.share = 0);
      }
      if (!newDistribution.value.origination) {
        distributionDetail.value.users.map(user => user.data.collected.distributionSummaryTotal -= user.data.origination.originatorDebit);
        distributionDetail.value.users.map(user => distributionDetail.value.data.collected.distributionSummaryTotal -= user.data.origination.originatorDebit);
        distributionDetail.value.data.origination.originatorDebit = 0;
        distributionDetail.value.users.map(user => user.data.origination.originatorDebit = 0);
      }
      if (!newDistribution.value.responsible) {
        distributionDetail.value.users.map(user => user.data.collected.distributionSummaryTotal -= user.data.origination.responsibleDebit);
        distributionDetail.value.users.map(user => distributionDetail.value.data.collected.distributionSummaryTotal -= user.data.origination.responsibleDebit);
        distributionDetail.value.data.origination.responsibleDebit = 0;
        distributionDetail.value.users.map(user => user.data.origination.responsibleDebit = 0);
      }
      if (!newDistribution.value.referral) {
        distributionDetail.value.users.map(user => user.data.collected.distributionSummaryTotal -= user.data.origination.referralDebit);
        distributionDetail.value.users.map(user => distributionDetail.value.data.collected.distributionSummaryTotal -= user.data.origination.referralDebit);
        distributionDetail.value.data.origination.referralDebit = 0;
        distributionDetail.value.users.map(user => user.data.origination.referralDebit = 0);
      }
      if (!newDistribution.value.expenses) {
        distributionDetail.value.users.map(user => user.data.collected.distributionSummaryTotal -= user.data.collected.expensesUsers);
        distributionDetail.value.users.map(user => distributionDetail.value.data.collected.distributionSummaryTotal -= user.data.collected.expensesUsers);
        distributionDetail.value.data.collected.expensesUsers = 0;
        distributionDetail.value.users.map(user => user.data.collected.expensesUsers = 0);
      }
    }
    getDistributionDetail();
    return {
      me,
      accounting,
      distributionDetail,
      showOrigination,
      loading,
      selectedDistributions,
      sectionToggle,
      print,
      exportCSV,
      getShortDateString,
      sendToQuickBooks,
      changeStatus,
      showDialog,
      newDistribution,
      applyDistributionSettings,
      cancelDistributionSettings,
      saveForFutureInfo,
      distributionStore,
      distributionChange,
      distributionNavigationStore
    };
  }
};